/**
 * 解析订单卡密字段：支持
 * - 单行旧数据
 * - 多行
 * - 【标签】卡密
 * @param {unknown} raw
 * @returns {Array<{ label: string, code: string }>}
 */
export function parseDeliveredCardSecrets(raw) {
  const text = String(raw == null ? '' : raw).replace(/\r\n/g, '\n').trim()
  if (!text) return []

  const lines = text.split('\n').map((l) => l.trim()).filter(Boolean)
  const items = []
  for (const line of lines) {
    const m = line.match(/^【([^】]+)】\s*(.+)$/)
    if (m) {
      items.push({ label: String(m[1]).trim(), code: String(m[2]).trim() })
    } else {
      items.push({ label: '', code: line })
    }
  }
  return items.filter((x) => x.code)
}

export function formatDeliveredCardSecretsText(raw) {
  return parseDeliveredCardSecrets(raw)
    .map((x) => (x.label ? `【${x.label}】${x.code}` : x.code))
    .join('\n')
}
